// Globals
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

// Store
import { selectProductSync } from '../../feature/selectors';
import { getProductSync, syncSpecificProduct } from '../../feature/actionCreators';

// Modules
import { selectChannels, selectChannelSlug } from '@/modules/Channels';
import { Header } from '@/modules/Layout';

// Store
import { useAppDispatch, useAppState } from '@/store';
import { syncByEntity } from '../../feature';

// Components
import { showSuccessToast, useForm } from '@/components';
import { Spinner } from '@/ui';
import { ProductsTable, ProductSyncForm } from '../../components';

// Helpers
import { SyncFormFormFields, SyncType, TSyncFormValues } from '../../helpers';
import { useGetEntities } from '../../hooks';
import { SyncByEntityDTO, SyncSpecificProductDTO } from '../../dtos';

const ProductsContainer = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const channels = useAppState(selectChannels);
  const currentChannelSlug = useAppState(selectChannelSlug);
  const productsSync = useAppState(selectProductSync);

  const { isLoading } = useGetEntities();

  const [productSyncForm] = useForm();

  const handleRunSync = async (values: TSyncFormValues) => {
    if (values.type === SyncType.SPECIFIC_PRODUCT) {
      await dispatch(syncSpecificProduct(new SyncSpecificProductDTO(values))).unwrap();
      return;
    }

    await dispatch(syncByEntity(new SyncByEntityDTO(values))).unwrap();
  };

  const handleSubmit = async (values: TSyncFormValues) => {
    try {
      await handleRunSync(values);
      productSyncForm.resetFields([
        SyncFormFormFields.CHANNEL,
        SyncFormFormFields.CHANNEL_SLUGS,
        SyncFormFormFields.SKU,
        SyncFormFormFields.UPDATED_FROM,
        SyncFormFormFields.UPDATED_UNTIL,
      ]);
      dispatch(getProductSync());
      showSuccessToast({
        message: t('message_sync_success'),
      });
    } catch {}
  };

  useEffect(() => {
    dispatch(getProductSync());
  }, [dispatch]);

  return (
    <>
      <Header title={t('menu_akeneo_products')} />
      <Spinner spinning={isLoading}>
        <ProductSyncForm
          onSubmit={handleSubmit}
          currentChannelSlug={currentChannelSlug}
          productSyncForm={productSyncForm}
          channels={channels ?? []}
        />
        <ProductsTable productsSync={productsSync} isLoading={isLoading} />
      </Spinner>
    </>
  );
};

export default ProductsContainer;
